/* eslint-disable camelcase */
import React, { useContext } from 'react'
import { Layout } from 'antd'
import { SiderProps } from 'antd/lib/layout'
import { ApplicationContext, EViewPort } from 'App/context'
import Footer from './Footer'
import SubBar from 'App/layouts/App/SubBar'
import TopBar from './TopBar'

type TProps = {
  children: any
}

const AppLayout = ({ children }: TProps) => {
  const ctx = useContext(ApplicationContext)

  const siderProperties: SiderProps = {
    trigger: null,
    width: 250,
    breakpoint: 'lg',
    collapsedWidth: '0',
    className: 'sider',
    collapsed: ctx.navigationCollapsed,
    onBreakpoint: (broken) => {
      ctx.setViewPort(broken ? EViewPort.mobile : EViewPort.desktop)
    },
  }

  const showBreadcrumb = () => {
    return ctx.showBreadcrumb ? <SubBar /> : null
  }

  return (
    <Layout
      className={['acc-app', ctx.viewPort === EViewPort.mobile ? 'mobile' : 'desktop'].join(' ')}
    >
      <Layout.Header className="acc-header acc-header-hootsuite-app">
        <TopBar />
      </Layout.Header>
      <Layout className="acc-app-body">
        <Layout className="acc-content">
          <Layout.Content className="content">
            {showBreadcrumb()}
            <div className="acc-content-children">{children}</div>
            <div className="acc-content-footer">
              <Footer />
            </div>
          </Layout.Content>
        </Layout>
      </Layout>
    </Layout>
  )
}

export default AppLayout
